export class ActivityLogsBaseRequest {
    StartDate: Date;
    EndDate: Date;
}
